import React, { useContext, useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, origin } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import useConfig from '../../../Hooks/useConfig';

export default function TicketsByGrade(props) {
    const { hover_type, student_number, decimalRange, department } = useConfig();
    var vData = props?.data;
    const [series, setSeries] = useState([]);
    const [chartLoaded, setChartLoaded] = useState(false);
    useEffect(() => {
        const vData = props?.data;
        const newSeries = vData?.series?.map(value => parseFloat(value)?.toFixed(decimalRange)) || [];
        setSeries(newSeries);
        setChartLoaded(true);
    }, [props.data]);
    const options = {
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top",
                },
            },
        },
        xaxis: {
            categories: vData?.categories || [],
            title: {
                text: department,
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return parseFloat(val)?.toFixed(decimalRange);
                },
            },
            title: {
                text: "No of Ticket",
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
            },
        },
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ["var(--primary-color)"],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Total Tickets : " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
    };
    const downloadCsv = () => {
        const csvContent = [];
        const gradeMap = new Map();
        props?.CsvData?.forEach((ticket) => {
            const grade = ticket?.inventory_management?.student_inventory?.student?.grade || 'Unknown';
            if (!gradeMap.has(grade)) {
                gradeMap.set(grade, []);
            }
            const rowData = {
                'Ticket Number': ticket.ticket_num,
                'Serial Number': ticket?.inventory_management?.serial_number,
                'Asset Tag': ticket?.inventory_management?.asset_tag,
                [student_number]: ticket?.inventory_management?.student_inventory?.student?.student_num,
                'Notes': ticket?.notes?.replace(/[,\r\n.]/g, ' '),
                'Return Location': ticket?.return_location?.name,
                'Ticket Status': ticket?.status?.status,
                'Created at': ticket.created_at ? formatDateToUsaMMDDYYYY(ticket.created_at) : '-',
            };
            gradeMap.get(grade).push(rowData);
        });
        gradeMap.forEach((gradeData, grade) => {
            csvContent.push([`Grade: ${grade}`]);
            const headers = ['Ticket Number', 'Serial Number', 'Asset Tag',
                student_number
                , 'Notes', 'Return Location', 'Ticket Status', 'Created at'];
            csvContent.push(headers);
            gradeData.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
            csvContent.push([]);
        });
        if (csvContent.length > 0) {
            const csvString = csvContent.map(row => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'TicketsByGrade.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            props.setAlerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
            setTimeout(() => {
                props.setAlerts(<AlertsComp show={false} />)
            }, 1500);
        }
    };


    return (
        <div className="text-center h-100 greyBox" >
            <div className="pb-5 w-100">
                <div className='row'>
                    <h4>Tickets By {department}</h4>
                </div>
                <div className='justify-content-center d-flex mb-3'>
                    <label className='cursor-pointer  d-flex align-items-center' onClick={downloadCsv} style={{ fontSize: "12px" }}>
                        <img src="/images/downloadPlan.svg" className="pe-1" title='Download CSV' height='10px' />
                        <label className='cursor-pointer'>Download Detailed Reports</label>
                    </label>
                </div>
                {props.loder == true ?
                    <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div>
                    :
                    <div id="chart">
                        {chartLoaded && (
                            <ReactApexChart options={options} series={[{ data: series }]} type="bar" height={350} />
                        )}
                    </div>
                }
            </div>
        </div>
    )
}
